import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Badge from '@material-ui/core/Badge';

import * as actions from '../solicitacao.action';
import SolicitacaoApi from '../solicitacao.api';

function Total () {
  const dispatch = useDispatch();
  const totalSolicitado = useSelector(
    state => state.solicitacao.totalSolicitado
  );

  useEffect(() => {
    SolicitacaoApi.getTotalSolicitados().then(data => {
      dispatch(actions.setTotalSolicitado(data));
    });
  }, []);
  return (
    <Badge
      color='primary'
      badgeContent={totalSolicitado}
      max={99}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
    >
      <i className='tab-icons mv-basico-dados_solicitacao'></i>
    </Badge>
  );
}

export default Total;



// WEBPACK FOOTER //
// ./src/pages/solicitacao/Total/index.js